import { jsxs, jsx } from 'react/jsx-runtime';
import { useId } from 'react';
import classNames from './RadioCard3.js';

const RadioCardItem = ({ option, groupName, value, hasErrors, onClick, size }) => {
    const inputId = useId();
    return (jsxs("label", { htmlFor: inputId, className: classNames.cardContainer(value === option.id, option.className, hasErrors, size), children: [jsx("input", { id: inputId, type: "radio", className: "w-0 h-0 overflow-hidden opacity-0 absolute", checked: option.id === value, onChange: (e) => {
                    onClick(option);
                    e.stopPropagation();
                    e.preventDefault();
                }, onFocus: () => {
                    if (option.id !== value)
                        onClick(option);
                }, name: groupName }), jsxs("div", { className: classNames.cardBox, children: [jsxs("div", { className: classNames.wrapper(option === null || option === void 0 ? void 0 : option.center), children: [option.iconStart && jsx(option.iconStart, { className: classNames.icon(size) }), jsxs("div", { className: classNames.body, children: [jsx("p", { className: classNames.label(size), children: option.label }), option.placeholder && jsx("p", { className: classNames.placeholder, children: option.placeholder })] })] }), option.iconEnd && jsx(option.iconEnd, { className: classNames.icon(size) })] })] }, option.id));
};

export { RadioCardItem };
